import React, { useEffect, useState, useRef } from "react";
import { db } from "./firebaseConfig";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import "./browse.css";

const BrowseQuizzes = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [flashcards, setFlashcards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const standardRef = useRef(null);
  const flashcardRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "quizzes"));
        const quizList = [];

        for (const docSnap of querySnapshot.docs) {
          const quizData = docSnap.data();
          if (quizData.public) {
            const userRef = doc(db, "users", quizData.authorId);
            const userSnap = await getDoc(userRef);
            const username = userSnap.exists() ? userSnap.data().username : "Unknown";
            quizList.push({ id: docSnap.id, ...quizData, authorUsername: username });
          }
        }

        const standardQuizzes = quizList.filter(q => q.quizType !== "flashcards");;
        const flashcardSets = quizList.filter(q => q.quizType === "flashcards");

        setQuizzes(standardQuizzes);
        setFlashcards(flashcardSets);
      } catch (err) {
        setError("Failed to fetch quizzes. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchQuizzes();
  }, []);

  if (loading) {
    return <p>Loading quizzes...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <>
      <Navbar />
      <div className="browse-container">
        <h2 className="browse-title">Browse Quizzes</h2>

        <div className="sticky-tabs">
          <button onClick={() => scrollToSection(standardRef)}>Standard Quizzes</button>
          <button onClick={() => scrollToSection(flashcardRef)}>Flashcards</button>
        </div>

        {quizzes.length > 0 && (
          <>
            <div ref={standardRef} id="standard-section">
              <h3 className="section-header">Standard Quizzes</h3>
              <div className="card-grid">
                {quizzes.map((quiz) => (
                  <div key={quiz.id} className="quiz-card">
                    <h4>{quiz.title}</h4>
                    <p>{quiz.description}</p>
                    <p><strong>Author:</strong> {quiz.authorUsername}</p>
                    <button onClick={() => navigate(`/view-quiz/${quiz.id}`)}>View Quiz</button>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {flashcards.length > 0 && (
          <>
            <div ref={flashcardRef} id="flashcard-section">
              <h3 className="section-header">Flashcard Sets</h3>
              <div className="card-grid">
                {flashcards.map((card) => (
                  <div key={card.id} className="quiz-card">
                    <h4>{card.title}</h4>
                    <p>{card.description}</p>
                    <p><strong>Author:</strong> {card.authorUsername}</p>
                    <button onClick={() => navigate(`/view-quiz/${card.id}`)}>View Flashcards</button>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BrowseQuizzes;